import { GravatarImage } from "~/ui/GravatarImage"

export const UserProfileImage = ({
  name,
  email,
  profileImageThumbUrl,
  className,
}: {
  name?: string | null
  email: string
  profileImageThumbUrl?: string | null
  className?: string
}) => {
  if (profileImageThumbUrl) {
    return (
      <img
        src={profileImageThumbUrl}
        alt={name || "Profile photo"}
        className={className}
      />
    )
  } else {
    return (
      <GravatarImage email={email} name={name || ""} className={className} />
    )
  }
}
